export default  function SupplierDashboard(){
    return <h1>Coming Soon</h1>;
  };